module.exports = __webpack_public_path__ + "img/zhrk.299e81d.png";